module.exports = __webpack_public_path__ + "static/gaza-cb6c51af08aa9a7521ba8e13f3bc742b.jpg";